<div class="stick-top">
  <mat-toolbar><mat-icon>hub</mat-icon> Clusters</mat-toolbar>
  <div class="hbox lightly-padded button-bar">
    <button mat-raised-button class="primary" routerLink="/cmdbClusters/0">
      <mat-icon aria-label="Create a new Cluster">add</mat-icon>
      Create a new Cluster
    </button>
  </div>
</div>

<div class="padded">
  <table class="basicTable">
    <thead>
    <tr>
      <th *ngIf="auth.isCompanyAdmin()" style="width: 75px;">
        <div class="vbox">
          Company
          <micro-company-select [(companyId)]="filter.companyId" ></micro-company-select>
        </div>
      </th>
      <th><div class="vbox">Cluster Name<input [(ngModel)]="filter.name"></div></th>
      <th><div class="vbox">Platform<micro-select-pagination apiUrl="/domain/cmdbHostingPlatform" [(id)]="filter.platformId" [defaultOption]="selectedPlatform" (objectChange)="selectedPlatform = $event" placeholder="Platform" [required]="false"></micro-select-pagination></div></th>
      <th><div class="vbox">Description<input [(ngModel)]="filter.description"></div></th>
      <th><div class="vbox">Active<input [(ngModel)]="filter.active"></div></th>
    </tr>
    </thead>
    <tbody>
    <tr *ngFor="let element of dataSource.data">
      <td *ngIf="auth.isCompanyAdmin()"><micro-company-lookup [companyId]="element.companyId"></micro-company-lookup></td>
      <td><a routerLink="/cmdbClusters/{{element.id}}">{{element.name}}</a></td>
      <td><a routerLink="/hostingPlatforms/{{element.platformId}}">{{platformNames.get(element.platformId) || element.platformId}}</a></td>
      <td>{{element.description}}</td>
      <td>{{element.active}}</td>
    </tr>
    <tr *ngIf="dataSource.data?.length === 0"><td colspan="100"><em>No results found</em></td></tr>
    </tbody>
    <tfoot><tr><td colspan="100">
      <mat-paginator #paginator (page)="reload()"></mat-paginator>
    </td></tr></tfoot>
  </table>
</div>
